import type { PagedResultDto } from "@services/dto/pagedResultDto"
import invitationService from "@services/invitation/invitationService"
import { action, makeAutoObservable, observable } from "mobx"

class InvitationStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await invitationService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await invitationService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default InvitationStore
